<ng-container *ifScreenSize="screenType.Desktop">
  <ng-container *notInPopulation="[populations.Kids]">
    <div
      class="bg-primary page-header-banner"
      *ngIf="showBanner"
      [style.background-image]="'url(' + ('banners/rewards-banner-desktop.jpeg' | contentAssetImage) + ')'"
    >
      <ng-container *ngIf="homepage; else pagelogo">
        <div class="container d-flex align-items-center justify-content-between w-100">
          <div class="d-flex flex-column text-white">
            <div class="d-flex align-items-center mb-2">
              <h1 class="me-1 font-size-20 mb-0">
                {{ 'home.page.welcome.text' | translate }} {{ (memberData$ | async)?.name }}!
              </h1>
              <span class="material-symbols-outlined">chevron_right</span>
            </div>
            <div class="font-size-14">{{ (memberData$ | async)?.memberId }} {{ 'home.page.member.id' | translate }}</div>
          </div>
          <div>
            <img class="home-banner-logo" [src]="'login-registrations/hawks-login-logo.png' | contentAssetImage" />
          </div>
        </div>
      </ng-container>
      <ng-template #pagelogo>
        <img class="h-100" [src]="'login-registrations/hawks-login-logo.png' | contentAssetImage" />
      </ng-template>
    </div>
  </ng-container>
  <ng-container *inPopulation="[populations.Kids]">
    <div class="bg-primary w-100" *ngIf="showBanner">
      <div class="container h-100">
        <img class="w-100 mb-3 rounded" [src]="kidsBanner | contentAssetImage" />
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ifScreenSize="screenType.Mobile">
  <div class="page-header bg-primary" [ngClass]="{ 'hide-footer': !showFooter }">
    <div class="d-flex align-items-center text-white">
      <div class="banner-name">
        <a (click)="goBack()" class="btn back-btn text-white px-0">
          <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
        </a>
        <h4 class="page-title mb-0 font-size-18" [ngClass]="{ 'text-title-center': !showBalance }">
          {{ pageTitle | translate | uppercase }}
        </h4>
      </div>
      <div class="ms-auto d-flex align-items-center font-size-14 widget-details" *ngIf="showBalance">
        <div class="balance-details d-flex bg-gradients align-items-center">
          <span class="icon material-icons">loyalty</span>
          <div class="balance">
            <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
          </div>
        </div>

        <button class="qrcode-btn text-white bg-gradients" routerLink="{{ qrButtonLink }}">
          <span class="icon material-icons material-mobile-nav">qr_code_2</span>
        </button>
      </div>
    </div>
    <ng-container *ngIf="showBanner">
      <ng-container *notInPopulation="[populations.Kids]">
        <div class="bg-primary">
          <img class="w-100 rounded mb-2" [src]="'banners/haws-rewards-banner.jpg' | contentAssetImage" />
        </div>
      </ng-container>
      <ng-container *inPopulation="[populations.Kids]">
        <div class="h-100">
          <img class="w-100 my-2 mb-3 rounded" [src]="kidsBanner | contentAssetImage" />
        </div>
      </ng-container>
    </ng-container>
    <div class="footer"></div>
  </div>
</ng-container>
